import difference from 'lodash/difference';
import { NOT_FOUND } from 'redux-first-router';

import {
    getCurrentRouteDesignerId,
    hasCurrentRouteDesigner,
} from '../reducers/designer';
import { getActiveSewpatId } from '../reducers/sewpats';

import * as types from './actionTypes';
import * as pdApiActions from './patterndesignActions';
import {
    fetchDesigner,
    loadColors,
    loadPatternsByCategory,
    loadPatternsFromDesigner,
} from './patterndesignActions';
import { setActiveSewpat } from './sewpats';

export const goHome = () => (
    {
        type: types.NAVIGATED_TO_HOME,
    }
);

export const goToAbout = () => (
    {
        type: types.NAVIGATED_TO_HOME,
    }
);

export const goToFAQFabrics = () => (
    {
        type: types.NAVIGATED_TO_FAQ_FABRICS,
    }
);

export const goToFAQShipping = () => (
    {
        type: types.NAVIGATED_TO_FAQ_SHIPPING,
    }
);

export const goToFavs = () => (
    {
        type: types.NAVIGATED_TO_LOVED_PATTERNS,
    }
);

export const goToNewest = () => (
    {
        type: types.NAVIGATED_TO_NEWEST_PATTERNGALLERY,
    }
);

export const goToFAQRecoloring = () => (
    {
        type: types.NAVIGATED_TO_FAQ_RECOLORING,
    }
);

export const goToCategory = categoryid => (
    {
        type: types.NAVIGATED_TO_SUBCATEGORIES,
        payload: { categoryid },
    }
);

export const goToCategoryPatterns = categoryid => (
    {
        type: types.NAVIGATED_TO_CATEGORIE_PATTERNS_GALLERY,
        payload: {
            categoryid,
            slug: 'patterns',
        },
    }
);

export const goToSewpatGallery = () => (
    {
        type: types.NAVIGATED_TO_SEWPAT_GALLERY,
    }
);

export const goToTopCategory = () => (
    {
        type: types.NAVIGATED_TO_TOPCATEGORIES,
    }
);

export const notFound = () => (
    {
        type: NOT_FOUND,
    }
);

export const goToSewpatPatterns = sewpatId => (
    {
        type: types.NAVIGATED_TO_SEWPAT_PATTERN_GALLERY,
        payload: { sewpatId },
    }
);

export const goToPattern = (patternid, sewpatId, query = {}) => (
    {
        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
        payload: {
            patternid,
            sewpatId,
        },
        query,
    }
);

export const goToSewpat = sewpatId => (
    {
        type: types.NAVIGATED_TO_SEWPAT_VIEW,
        payload: {
            sewpatId,
        },
    }
);

export const goToSubCategory = (sewpatId, categoryid) => (
    {
        type: types.NAVIGATED_TO_SEWPAT_PATTERN_GALLERY,
        payload: {
            sewpatId,
            categoryid,
        },
    }
);

export const setPage = pageNumber => (dispatch, getState) => {
    const state = getState();
    const type = state.location.type;
    const page = pageNumber || 1;
    const query = state.location.query;
    const payload = state.location.payload;
    const newQuery = Object.assign({}, query, { page });

    return dispatch({
        type,
        query: newQuery,
        payload,
    });
};

/**
 * Loads a pattern from a route. This is the default route callback for
 * the single pattern view.
 *
 * @returns {function(*, *)}
 */
export function loadPatternFromRoute() {
    return async (dispatch, getState) => {
        const state = getState();
        const { patternid } = state.location.payload;
        const { patterns } = state.stolo.entities;
        const sewpatId = getActiveSewpatId(state);

        if (sewpatId) {
            dispatch(setActiveSewpat(sewpatId));
        }
        const idsToFetch = difference([patternid], patterns.items);
        var designerId = (
            patterns.entities[patternid] || {}
        ).designer || null;

        if (designerId && !patterns.didInvalidate) {
            await dispatch(pdApiActions.fetchDesigner(designerId));
        }
        else {
            // If the entities somehow invalidated we have to fetch them.
            if (patterns.didInvalidate || idsToFetch.length > 0) {
                const result = await dispatch(
                    pdApiActions.fetchPatterns({ ids: [patternid] }));
                var designerId = await getDesignerIdFromPatternRequest(result);
                if (designerId) {
                    await dispatch(pdApiActions.fetchDesigner(designerId));
                }
            }
        }

        const colors = dispatch(loadColors(patternid));
        await Promise.all([colors]);
        return Promise.resolve();
    };
}

/**
 * Loads a sewing pattern from a route. This is the default route callback for
 * the single sewpat view.
 *
 * @returns {function(*, *)}
 */
export function loadSewpatFromRoute() {
    return (dispatch, getState) => {
        const { sewpatId } = getState().location.payload;
        dispatch(setActiveSewpat(sewpatId));
        return Promise.resolve();
    };
}

const getDesignerIdFromPatternRequest = async result => {
    if (result.response.result.result !== 'SUCCESS') {
        return Promise.reject(new Error('No designer data available'));
    }
    const { designer } = result.response.entities;
    const ids = Object.keys(designer);
    if (!ids) {
        return Promise.reject(new Error('No designer data available'));
    }
    return ids[0];
};

/**
 * Load the patterns by categorie. The current categorie id comes from the
 * route.
 *
 * @returns {function(*, *)}
 */
export const patternsByCategory = () => (dispatch, getState) => {
    const state = getState();
    const { categoryid, sewpatId } = state.location.payload;
    dispatch(setActiveSewpat(sewpatId));
    return dispatch(loadPatternsByCategory(categoryid));
};

/**
 * Load the newest patterns from specified designer.
 */
export const patternsFromDesigner = () => async (dispatch, getState) => {
    const state = getState();
    const designerid = getCurrentRouteDesignerId(state);
    const { sewpatId } = state.location.payload;
    dispatch(setActiveSewpat(sewpatId));
    if (!hasCurrentRouteDesigner(state)) {
        await dispatch(fetchDesigner(designerid));
    }
    await dispatch(loadPatternsFromDesigner(designerid));
    return Promise.resolve();
};

/**
 * Performs a search for patterns with the current query.
 *
 * @returns {function(*, *)}
 */
export const siteSearch = () => async (dispatch, getState) => {
    const state = getState();
    const query = state.location.query || {};
    // We do not need to perform a search if we have no valid search value.
    if (query.q === undefined || query.q.length < 3) {
        return Promise.resolve();
    }
    await dispatch(pdApiActions.loadPatternsFromSearch(query.q));
    return Promise.resolve();
};



// WEBPACK FOOTER //
// ./src/actions/navigation.js